export enum ProductClassifications {
    Beverage = 'Beverage',
    CityTax = 'CityTax',
    Food = 'Food',
    Wellness = 'Wellness',
}
